import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=7230a4a4&scoped=true&"
import script from "./LightBox.vue?vue&type=script&lang=js&"
export * from "./LightBox.vue?vue&type=script&lang=js&"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=7230a4a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7230a4a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7230a4a4')) {
      api.createRecord('7230a4a4', component.options)
    } else {
      api.reload('7230a4a4', component.options)
    }
    module.hot.accept("./LightBox.vue?vue&type=template&id=7230a4a4&scoped=true&", function () {
      api.rerender('7230a4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/files/LightBox.vue"
export default component.exports